import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CarritoService } from '../../services/carrito.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-success',
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './success.component.html',
  styleUrl: './success.component.scss'
})
export class SuccessComponent implements OnInit {

  public showSpinner: boolean = true;
  public showError: boolean = false;
  public detalleComra: any = {};

  constructor(private carritoService: CarritoService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    const paymentId = this.route.snapshot.queryParams['payment_id'];
    const guid = this.route.snapshot.queryParams['preference_id'];
    const payment_method = this.route.snapshot.queryParams['payment_method'];
    const numeroOrden = this.route.snapshot.queryParams['numero_orden'];
    const email = this.route.snapshot.queryParams['email'];
    let $call: any = {};

    if (payment_method === 'transferencia') {
      $call = this.carritoService.obtenerOrdenCompraTransferencia({
        _id: numeroOrden,
        email: email
      });
      this.carritoService.clearCarrito();
    } else {
      $call = this.carritoService.finalizarCompra({
        guid: guid,
        paymentId: paymentId
      });
    }
    $call.subscribe({
      next: (response: any) => {
        this.showSpinner = false;
        this.detalleComra = response.order;
      }, error: () => {
        this.showError = true;
        this.showSpinner = false;
      }
    });
  }


}
